import { fabric } from "fabric"
import DrawableMixin from "@/signomatic/app/objects/drawable_mixin"

const GroupObject = DrawableMixin(fabric.Group)

export default GroupObject
